import { BackButton } from "@/components/custom/BackButton"
import { PageTitle } from "@/components/custom/PageTitle"
import { RootState } from "@/redux"
import { useSelector } from "react-redux"
import { PageDescription } from "@/components/custom/PageDescription"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { UserRole } from "@/constants/users/userRole"
import { TCSApplications } from "@/components/custom/AvailableTCSApplications/TCSApplications"
import { isActiveSubscription } from "@/helpers/billing"

export const WorkflowSelectSource = () => {
  const navigate = useNavigate()
  const { userData } = useSelector((state: RootState) => state.user)
  const { applications } = useSelector((state: RootState) => state.application)
  const billingSubscription = useSelector((state: RootState) => state.billing?.subscription)

  useEffect(() => {
    if (userData?.role === UserRole.USER) {
      navigate('/workflows')
    }
  }, [userData, navigate])

  useEffect(() => {
    if (billingSubscription !== undefined && !isActiveSubscription(billingSubscription)) {
      navigate('/billing')
    }
  }, [billingSubscription, navigate])

  return (
    <div className="protectedPageLayout">
      <BackButton buttonLink="/workflows" buttonText="Back to Workflows" />
      <PageTitle title="Create a Workflow" />
      <PageDescription
        title=""
        subtitle="Where is data coming from?"
      />
      <TCSApplications applications={applications} navigatePath="/workflows/create" />
    </div>
  )
}
